import { __extends } from "tslib";
import * as React from "react";
import * as cx from "classnames";
import "./Modal.css";
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClose = function () {
            var onClose = _this.props.onClose;
            if (onClose) {
                onClose();
            }
        };
        return _this;
    }
    Modal.prototype.render = function () {
        var _a = this.props, boxClassName = _a.boxClassName, className = _a.className, isOpen = _a.isOpen, title = _a.title, children = _a.children, small = _a.small;
        if (!isOpen) {
            return null;
        }
        var titleElement = title ? (React.createElement("div", { className: cx("Modal__title", { "Modal__title--small": small }) }, title)) : null;
        return (React.createElement("div", { className: cx("Modal", className) },
            React.createElement("div", { className: "Modal__overlay", onClick: this.handleOnClose, "data-testid": "modal-overlay" },
                React.createElement("div", { className: cx("Modal__box", { "Modal__box--small": small }, boxClassName), onClick: function (e) { return e.stopPropagation(); } },
                    titleElement,
                    React.createElement("div", { className: "Modal__content" }, children)))));
    };
    Modal.defaultProps = {
        isOpen: false,
        small: false
    };
    return Modal;
}(React.Component));
export default Modal;
